var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"component legal-admin"},[_c('div',{staticClass:"overview-box"},[_c('case-overview-component',{attrs:{"menuType":'legal-admin'}})],1),_c('div',[_c('rank-data-box',{attrs:{"menuType":'legal-admin'}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }